import { FC, SVGProps } from "react";

export const TrendLineIcon: FC<SVGProps<SVGSVGElement>> = ({
  fill = "white",
  className,
  width = 16,
  height = 16,
  style,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        ...style,
      }}
      {...props}
    >
      <path
        d="M5 12l-1-1 6.8-6.8 1.1 1.1C8.2 8.8 8.7 8.4 5 12zm-2.9-.2c1.2 0 2.1 1 2.1 2.2 0 1.1-1 2.1-2.1 2C.9 16 0 15 0 13.9s1-2.1 2.1-2.1z"
        fill={fill}
      ></path>
      <circle cx="13.9" cy="2.1" r="2.1" fill={fill}></circle>
    </svg>
  );
};
